import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Loader } from "../ui/loader";
import { DangerAlert, WarningAlert } from "./Alerts";

export const ModalContentLoading = ({
  className,
  description = "Loading content...",
  onOpenChange,
  title,
}: {
  className?: string;
  description?: string;
  onOpenChange: (open: boolean) => void;
  title: string;
}) => {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className={className}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{description}</DialogDescription>
        <Loader />
      </DialogContent>
    </Dialog>
  );
};

export const ModalContentError = ({
  className,
  description = "An error occurred.",
  onOpenChange,
}: {
  className?: string;
  description?: string;
  onOpenChange: (open: boolean) => void;
}) => {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className={className} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>An error occurred.</DialogTitle>
        </DialogHeader>
        <DangerAlert>{description}</DangerAlert>
      </DialogContent>
    </Dialog>
  );
};

export const ModalContentEmpty = ({
  className,
  description = "Requested content was not found.",
  onOpenChange,
}: {
  className?: string;
  description?: string;
  onOpenChange: (open: boolean) => void;
}) => {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className={className} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Requested content was not found.</DialogTitle>
        </DialogHeader>
        <WarningAlert>{description}</WarningAlert>
      </DialogContent>
    </Dialog>
  );
};
